const namespaced = true

import api from '../../../api/sap/business_partner.js';
import apiCie from '../../../api/sales/cie.js';
import { downloadFile } from '../../../src/helpers/util.js'

import _ from "lodash";

const state = {
    businessPartner: null,
    businessPartners: [],
    customers: [],
    customersChangeCie: [],
    flagButton: false,
    countChange: 0,
    countNoChange: 0,
    loading: false,
}
const mutations = {
    MUTATION_SET_BUSINESS_PARTNER(state, data) {
        state.businessPartner = data;
    },
    MUTATION_SET_BUSINESS_PARTNERS(state, data) {
        state.businessPartners = data;
    },
    SET_LOADING(state, val) {
        state.loading = val;
    },
    MUTATION_SET_BUSINESS_PARTNERS_CUSTOMERS(state, data) {
        state.flagButton = false;
        state.countChange = 0;
        state.countNoChange = 0;
        const customersClone = _.cloneDeep(data);
        const customersChangeClone = _.cloneDeep(data);
        state.customers = _.orderBy(customersClone, [item => _.some(item.banks, { need_update: true })], ['desc']);
        state.customersChangeCie = _.filter(customersChangeClone, item => {
            item.banks = _.filter(item.banks, { need_update: true });
            return item.banks.length > 0;
        });
        state.countNoChange = state.customersChangeCie.length;
    }
    ,
    MUTATION_SET_BUSINESS_PARTNERS_CUSTOMERS_CHANGE(state) {
        state.countNoChange = 0;
        state.customers = state.customersChangeCie;
        state.flagButton = true;
    }
}
const actions = {
    getBusinessPartner(context, data) {
        api.search(data).then(function (res) {
            context.commit('MUTATION_SET_BUSINESS_PARTNER', res.data);
        }).catch((e) => {
            context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
        })
    },
    getByCardType(context, data) {
        api.showByCardType(data).then(function (res) {
            context.commit('MUTATION_SET_BUSINESS_PARTNERS', res.data);
        }).catch((e) => {
            context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
        })
    },
    getCustomers(context) {
        context.commit("SET_LOADING", true);
        api.customers().then(function (res) {
            context.commit('MUTATION_SET_BUSINESS_PARTNERS_CUSTOMERS', res.data);
            context.commit("SET_LOADING", false);
        }).catch((e) => {
            context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            context.commit("SET_LOADING", false);
        })
    },
    changeCustomersChange(context) {
        context.commit('MUTATION_SET_BUSINESS_PARTNERS_CUSTOMERS_CHANGE');
        context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Actualizados correctamente' }, { root: true });
    },
    changeOneCustomer(context, data) {
        api.customersOneChange(data).then(function () {
            context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': 'Actualizado correctamente' }, { root: true });
        }).catch((e) => {
            context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
        })

    },
    exportPdf(context, data) {
        return new Promise((resolve) => {
            apiCie.exportPdf(data.data)
                .then(function (res) {
                    downloadFile(res.data, data.data.CardCode +'.pdf');
                    resolve(res); 
                })
                .catch(() => {
                    context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': 'No pudo generar el pdf' }, { root: true });
                });
        });
    }
}

const getters = {
    getBusinessPartnerRfC(state) {
        return (state.businessPartner != null) ? state.businessPartner[0].LicTradNum : null
    },
    getBusinessPartnerBalance(state) {
        return (state.businessPartner != null) ? state.businessPartner[0].Balance : null
    },
    getBusinessPartnerCardCode(state) {
        return (state.businessPartner != null) ? state.businessPartner[0].CardCode : null
    },
    getBusinessPartnerCardName(state) {
        return (state.businessPartner != null) ? state.businessPartner[0].CardName : null
    },
    getBusinessPartnerCurrency(state) {
        return (state.businessPartner != null) ? state.businessPartner[0].Currency : null
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}